import React, { Component } from 'react'
import LoginButton from './LoginButton'
import LoginWithEmail from './LoginWithEmail'
import ResetPassword from './ResetPassword'
import LoginWithFacebook from './LoginWithFacebook'
import LoginWithGoogle from './LoginWithGoogle'
import ClickOutside from 'react-click-outside'

export default class LoginWidget extends Component {
  state = {
    showLoginForm: false,
    showResetPassword: false
  }

  handleLoginButtonClick = () => {
    this.setState({showLoginForm: !this.state.showLoginForm, showResetPassword: false})
  }

  handleClickOutside = () => {
    this.setState({showLoginForm: false, showResetPassword: false})
  }

  handleResetPasswordClick = (e) => {
    e.preventDefault()
    this.setState({showResetPassword: true})
  }

  renderLogin() {
    const { expanded } = this.props
    return (
      <div className={`login__form ${expanded ? 'relative' : 'absolute'}`}>
        <LoginWithEmail />

        <div className="login__form__or">or</div>
        <div className="social__button__wrapper">
          <div><LoginWithFacebook /></div>
          <div><LoginWithGoogle /></div>
        </div>
        <div className="login__forgot__password">
          <a href="#reset_password" onClick={this.handleResetPasswordClick}>I forgot my username or password</a>
        </div>
      </div>
    )
  }

  renderForgotPassword() {
    const { expanded } = this.props
    return (
      <div className={`login__form ${expanded ? 'relative' : 'absolute'}`}>
        <ResetPassword />
      </div>
    )
  }

  render() {
    const { expanded } = this.props
    const { showLoginForm, showResetPassword } = this.state

    if(expanded) {
      return showResetPassword ? this.renderForgotPassword() : this.renderLogin()
    }
    else {
      return (
          <div className="login__form__wrapper">
            { showLoginForm &&
              <ClickOutside onClickOutside={this.handleClickOutside}>
                { showResetPassword ? this.renderForgotPassword() : this.renderLogin() }
              </ClickOutside>
            }
          <LoginButton onClick={this.handleLoginButtonClick} />
        </div>
      )
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/LoginWidget/index.js